import { Select } from '@mantine/core';
import { useMediaDeviceSelect } from '@livekit/components-react';
import { useTranslation } from 'react-i18next';
import { i18n } from '@/i18n';
import { notifyError } from '@/shared/notify';

const onDeviceListError = (error: Error) => {
    notifyError(i18n.t('settings:device.listFailed'), error);
};

export function DeviceSelect({ kind, label }: Readonly<{ kind: MediaDeviceKind; label: string }>) {
    const { t } = useTranslation('settings');
    const { devices, activeDeviceId, setActiveMediaDevice } = useMediaDeviceSelect({ kind, onError: onDeviceListError });

    return (
        <Select
            allowDeselect={false}
            comboboxProps={{ withinPortal: false }}
            data={devices.map((d) => ({ value: d.deviceId, label: d.label || t('device.unnamed') }))}
            label={label}
            placeholder={t('device.notFound')}
            value={devices.length > 0 ? activeDeviceId : null}
            onChange={(value) => {
                if (value) {
                    setActiveMediaDevice(value).catch((error: unknown) => {
                        notifyError(t('device.switchFailed'), error);
                    });
                }
            }}
        />
    );
}
